import { getJson, postJson } from './client'
import type { BriefView } from '../types/reports'

// Reports: the per-account meeting-prep brief. The weekly update lives in api/weekly.ts.
const s = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout`

export const reportsApi = {
  /** Writes a fresh brief now and keeps it. */
  brief: (spoke: string, companyId: string) => postJson<BriefView>(`${s(spoke)}/accounts/${encodeURIComponent(companyId)}/brief`, {}),
  /** The brief already on file — written by the night ahead of a meeting, or by hand. 404 when none. */
  storedBrief: (spoke: string, companyId: string) => getJson<BriefView>(`${s(spoke)}/accounts/${encodeURIComponent(companyId)}/brief`),
}
